// @ts-ignore Variable replacement from DefinePlugin
export const aikey = function (): string { return __AIKEY__; };